/**
 * Three Card Brag — the British three-card betting game.
 *
 * Betting, blind/seen play, side shows, show and pot limit are exactly Teen Patti's. The ranking is
 * Prial (three of a kind, 3-3-3 highest then A-A-A down to 2-2-2) > Running flush > Run > Flush > Pair > High card,
 * with A-2-3 the top run. It reuses the Teen Patti engine with `bragRanking` switched on and its own game type.
 */
import { teenPattiEngine, type TeenPattiAction, type TeenPattiConfig, type TeenPattiLegal, type TeenPattiState, type TeenPattiView } from '../teenpatti/engine.js';
import type { GameEngine } from '../../core/types.js';

export type BragConfig = TeenPattiConfig;
export type BragState = TeenPattiState;
export type BragAction = TeenPattiAction;
export type BragLegal = TeenPattiLegal;
export type BragView = Omit<TeenPattiView, 'gameType'> & { gameType: 'BRAG' };

export const bragEngine: GameEngine<BragConfig, BragState, BragAction, BragView, BragLegal> = {
  ...teenPattiEngine,
  gameType: 'BRAG',
  defaultConfig: () => ({ ...teenPattiEngine.defaultConfig(), bragRanking: true }),
  normalizeConfig: (input) => teenPattiEngine.normalizeConfig({ bragRanking: true, ...input, flushRanking: false, variant: 'classic' }),
  getView: (s, seat) => ({ ...teenPattiEngine.getView(s, seat), gameType: 'BRAG' }) as BragView,
};
